type BlogOutput = {
  toBase64: (file: Blob | null) => Promise<string>
  CreateBlobFromUrl: (url: string) => Promise<Blob | undefined>
  downloadURI: (uri: string, name: string) => void
}

function useBlob(): BlogOutput {
  const toBase64 = (file: Blob | null): Promise<string> =>
    new Promise((resolve, reject) => {
      if (file === null) {
        reject(new Error('Blog is null'))
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(file) // , 'windows-1252')
      reader.onloadend = () => {
        let base64String = ''
        if (reader.result) {
          base64String = reader.result
            .toString()
            .replace('data:', '')
            .replace(/^.+,/, '')
        }
        resolve(base64String)
      }
      reader.onerror = error => reject(error)
    })

  const downloadURI = (uri: string, name: string): void => {
    const link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const CreateBlobFromUrl = (url: string): Promise<Blob | undefined> =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        resolve(xhr.response)
      }
      xhr.onerror = e => {
        reject(e)
      }
      xhr.send()
    })

  return { toBase64, CreateBlobFromUrl, downloadURI }
}

export default useBlob
